import { AdministrateurBien, Utilisateur } from "../../../services/Api/swagger";

export const renderAdbList = (
  utilisateur?: Utilisateur,
  adbRegroupementList?: AdministrateurBien[]
) => {
  if (utilisateur) {
    if (utilisateur.role === "BESSE") {
      return adbRegroupementList;
    } else {
      const adbList =
        utilisateur.detailAdbProfilSites &&
        utilisateur.detailAdbProfilSites.map((adb) => ({
          identifiant: adb.refAdb,
          nom: adb.nomAdb,
        }));
      return adbList;
    }
  } else {
    return null;
  }
};

export const buildInitialValues = (utilisateur: Utilisateur) => {
  const initialValues = {
    ...utilisateur,
    fonction: utilisateur.fonction?.toString(),
    listAdb:
      utilisateur.detailAdbProfilSites &&
      utilisateur.detailAdbProfilSites.map((detail) => ({
        key: detail.refAdb,
        text: detail.nomAdb,
        value: detail.refAdb?.toString(),
      })),
    adbs:
      utilisateur.detailAdbProfilSites &&
      utilisateur.detailAdbProfilSites.map((detail) => ({
        refAdb: detail.refAdb?.toString(),
        profil: detail.profil?.toString(),
        sites:
          detail.sites &&
          detail.sites.map((site) => ({
            key: detail.refAdb && site + detail.refAdb,
            value: site,
          })),
      })),
  };
  return initialValues;
};
